const pages = [
  {
    label: "Experience Zone",
    href: "cez",
  },
  {
    label: "Bot Store",
    href: "BotStore",
  },
  {
    label: "Employee Twin",
    href: "NewEmployeetwin",
  },
  {
    label: "Product",
    href: "products",
  },
  {
    label: "Approvals",
    href: "Approvals",
  },
  {
    label: "H.O.F",
    href: "hall-of-fame",
  },
  {
    label: "Contact Us",
    href: "ContactUs",
  },
  {
    label: "ROI",
    href: "return-on-investment",
  },
];

export default pages;

